import React from "react";

const PrivacyPolicy = () => {
  const containerStyle = {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "40px 20px",
    fontFamily: "'Inter', sans-serif",
    lineHeight: "1.6",
    color: "#334155",
    backgroundColor: "#fff"
  };

  const headerStyle = {
    fontSize: "32px",
    fontWeight: "800",
    color: "#0f172a",
    marginBottom: "24px",
    borderBottom: "4px solid #FF6B00",
    display: "inline-block",
    paddingBottom: "8px"
  };

  const sectionHeaderStyle = {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1e293b",
    marginTop: "32px",
    marginBottom: "12px"
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Privacy Policy</h1>
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      
      <p>
        QuickBill ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by QuickBill.
      </p>

      <h2 style={sectionHeaderStyle}>1. Information We Collect</h2>
      <p>
        We collect information that you provide directly to us when you create an account, use our services, or communicate with us. This may include:
      </p>
      <ul>
        <li><strong>Account Information:</strong> Name, email address, phone number, and business details.</li>
        <li><strong>Transaction Data:</strong> Details about sales, orders, and inventory managed through the app.</li>
        <li><strong>Usage Information:</strong> We may collect logs of your interactions with our app for security and performance auditing.</li>
      </ul>

      <h2 style={sectionHeaderStyle}>2. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Provide, maintain, and improve our services.</li>
        <li>Process transactions and send related information.</li>
        <li>Send technical notices, updates, and security alerts.</li>
        <li>Respond to your comments and questions.</li>
      </ul>

      <h2 style={sectionHeaderStyle}>3. Data Storage and Security</h2>
      <p>
        Your data is stored securely using enterprise-grade cloud infrastructure (Firebase/Supabase). We implement industry-standard security measures to protect your information from unauthorized access, alteration, or destruction.
      </p>

      <h2 style={sectionHeaderStyle}>4. Data Sharing</h2>
      <p>
        We do not sell your personal data. We only share information with third-party service providers (like Firebase) as necessary to provide our services, or when required by law.
      </p>

      <h2 style={sectionHeaderStyle}>5. Your Rights</h2>
      <p>
        You have the right to access, correct, or delete your personal data. You can manage your account settings within the app or contact us for assistance.
      </p>

      <h2 style={sectionHeaderStyle}>6. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at support@quickbill.com.
      </p>

      <div style={{ marginTop: "60px", padding: "20px", background: "#f8fafc", borderRadius: "12px", fontSize: "14px", borderLeft: "4px solid #cbd5e1" }}>
        <p><strong>Note for Play Store Reviewers:</strong> This application is a B2B tool for enterprise resource planning and inventory management. All data collection is strictly for the purpose of business operations.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
